var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-floater"},[_c('img',{attrs:{"src":require("../../content/images/favicon.svg"),"id":"logo","alt":"smartyfile"}}),_c('div',{staticClass:"container"},[_c('form',{ref:"logout",attrs:{"method":"post","action":'/sso/logout?_csrf=' + _vm.csrfToken}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }